const PREFIX = 'LIVE'

enum LiveConstants {
    LIVE_INITIALIZE,
    LIVE_INITIALIZE_SUCCESS,
    LIVE_INITIALIZE_ERROR,
    STORE_LIVE_INITIALIZE,
    STORE_LIVE_INITIALIZE_ERROR,
    GET_LIVE_SETTINGS,
    GET_LIVE_SETTINGS_SUCCESS,
    DELETE_LIVE_SETTINGS,
    DELETE_LIVE_SETTINGS_SUCCESS,
    GET_LIVE_EVENTS,
    GET_LIVE_EVENTS_ERROR,
    GET_LIVE_EVENTS_SUCCESS,
    NEW_LIVE_EVENT,
    EDIT_LIVE_EVENT,
    CLEAR_LIVE_EVENT,
    NEW_BOOKED_EVENT,
    BOOK_EVENT,
    BOOK_EVENT_SUCCESS,
    BOOK_EVENT_ERROR,
    GET_EVENT,
    GET_EVENT_SUCCESS,
    GET_EVENT_ERROR,
    DELETE_ALERT,
    DELETE_ALERT_SUCCESS,
    HIDE_ALERT,
    HIDE_ALERT_SUCCESS,
    NEW_HIDDEN_ALERT,
    GET_LIVE_ODDS_EVENTS_SUCCESS,
    GET_LIVE_ODDS_EVENTS,
    GET_EVENTS,
    GET_EVENTS_SUCCESS,
}

const SETTINGS = 'SETTINGS'

enum SettingConstants {
    SET_ORDER,
    SET_SPORT_FILTER,
    SET_SETTINGS,
}

export enum OrderConstants {
    NONE,
    DATE,
    MARGIN,
    COMPARISON,
    BOOK
}

export const STORE_LIVE_INITIALIZE = PREFIX + '_' + LiveConstants.STORE_LIVE_INITIALIZE;
export const STORE_LIVE_INITIALIZE_ERROR = PREFIX + '_' + LiveConstants.STORE_LIVE_INITIALIZE_ERROR;
export const LIVE_INITIALIZE = PREFIX + '_' + LiveConstants.LIVE_INITIALIZE;
export const LIVE_INITIALIZE_SUCCESS = PREFIX + '_' + LiveConstants.LIVE_INITIALIZE_SUCCESS;
export const LIVE_INITIALIZE_ERROR = PREFIX + '_' + LiveConstants.LIVE_INITIALIZE_ERROR;

export const GET_LIVE_SETTINGS = PREFIX + '_' + LiveConstants.GET_LIVE_SETTINGS;
export const GET_LIVE_SETTINGS_SUCCESS = PREFIX + '_' + LiveConstants.GET_LIVE_SETTINGS_SUCCESS;
export const DELETE_LIVE_SETTINGS = PREFIX + '_' + LiveConstants.DELETE_LIVE_SETTINGS;
export const DELETE_LIVE_SETTINGS_SUCCESS = PREFIX + '_' + LiveConstants.DELETE_LIVE_SETTINGS_SUCCESS;

export const GET_LIVE_EVENTS = PREFIX + '_' + LiveConstants.GET_LIVE_EVENTS;
export const GET_LIVE_EVENTS_ERROR = PREFIX + '_' + LiveConstants.GET_LIVE_EVENTS_ERROR;
export const GET_LIVE_EVENTS_SUCCESS = PREFIX + '_' + LiveConstants.GET_LIVE_EVENTS_SUCCESS;
export const NEW_LIVE_EVENT = PREFIX + '_' + LiveConstants.NEW_LIVE_EVENT;
export const EDIT_LIVE_EVENT = PREFIX + '_' + LiveConstants.EDIT_LIVE_EVENT;
export const CLEAR_LIVE_EVENT = PREFIX + '_' + LiveConstants.CLEAR_LIVE_EVENT;

export const GET_LIVE_ODDS_EVENTS = PREFIX + '_' + LiveConstants.GET_LIVE_ODDS_EVENTS;
export const GET_LIVE_ODDS_EVENTS_SUCCESS = PREFIX + '_' + LiveConstants.GET_LIVE_ODDS_EVENTS_SUCCESS;

export const GET_EVENT = PREFIX + '_' + LiveConstants.GET_EVENT;
export const GET_EVENT_SUCCESS = PREFIX + '_' + LiveConstants.GET_EVENT_SUCCESS;
export const GET_EVENT_ERROR = PREFIX + '_' + LiveConstants.GET_EVENT_ERROR;
export const GET_EVENTS = PREFIX + '_' + LiveConstants.GET_EVENTS;
export const GET_EVENTS_SUCCESS = PREFIX + '_' + LiveConstants.GET_EVENTS_SUCCESS;

export const BOOK_EVENT = PREFIX + '_' + LiveConstants.BOOK_EVENT;
export const BOOK_EVENT_SUCCESS = PREFIX + '_' + LiveConstants.BOOK_EVENT_SUCCESS;
export const BOOK_EVENT_ERROR = PREFIX + '_' + LiveConstants.BOOK_EVENT_ERROR;

export const NEW_BOOKED_EVENT = PREFIX + '_' + LiveConstants.NEW_BOOKED_EVENT;
export const DELETE_ALERT = PREFIX + '_' + LiveConstants.DELETE_ALERT;
export const DELETE_ALERT_SUCCESS = PREFIX + '_' + LiveConstants.DELETE_ALERT_SUCCESS;
export const HIDE_ALERT = PREFIX + '_' + LiveConstants.HIDE_ALERT;
export const HIDE_ALERT_SUCCESS = PREFIX + '_' + LiveConstants.HIDE_ALERT_SUCCESS;
export const NEW_HIDDEN_ALERT = PREFIX + '_' + LiveConstants.NEW_HIDDEN_ALERT;

export const SET_SPORT_FILTER = SETTINGS + '_' + SettingConstants.SET_SPORT_FILTER;
export const SET_ORDER = SETTINGS + '_' + SettingConstants.SET_ORDER;
export const SET_SETTINGS = SETTINGS + '_' + SettingConstants.SET_SETTINGS;
